// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageUploader_root__1dL2d","imageBox":"ImageUploader_imageBox__34T4Q","remove":"ImageUploader_remove__2lgiA","upload":"ImageUploader_upload__1vNfe"};